import { stats } from "@/mocks/content";

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Soft%20abstract%20flowing%20organic%20shapes%20in%20warm%20sandy%20beige%20and%20creamy%20ivory%20tones%2C%20subtle%20layered%20textures%20resembling%20fine%20linen%20fabric%2C%20gentle%20diffused%20light%20gradients%2C%20minimalist%20artistic%20composition%2C%20no%20objects%2C%20serene%20peaceful%20atmosphere%2C%20editorial%20quality%2C%20harmonious%20warm%20color%20palette&width=1600&height=900&seq=hero-bg-v2-fresh-016&orientation=landscape"
          alt="VigorBuy Spreadsheet Hub lifestyle background"
          title="VigorBuy Spreadsheet Hub"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/15 to-black/35"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 text-center lg:text-left pt-20 md:pt-0">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-background-50/20 backdrop-blur-sm border border-background-50/30 mb-6">
              <i className="ri-sparkling-2-line text-primary-300 text-sm w-4 h-4 flex items-center justify-center"></i>
              <span className="text-xs font-medium text-background-50 tracking-wide">Updated June 2026</span>
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight mb-5">
              The Largest Updated{" "}
              <span className="italic">VigorBuy Spreadsheet</span>{" "}
              in 2026
            </h1>

            <p className="text-base md:text-lg text-background-50/85 max-w-xl mx-auto lg:mx-0 mb-8 leading-relaxed">
              Discover the latest Vigorbuy Spreadsheet, trusted finds, QC guides, shipping tutorials, and buying resources updated daily.
            </p>

            <div className="flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="w-full sm:w-auto px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-all whitespace-nowrap text-center cursor-pointer"
              >
                Explore Spreadsheet
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="w-full sm:w-auto px-8 py-3.5 rounded-full border-2 border-background-50/40 text-background-50 font-semibold text-sm hover:bg-background-50/10 transition-all whitespace-nowrap text-center cursor-pointer"
              >
                Buy It Now
              </a>
            </div>

            <div className="flex flex-wrap items-center gap-3 mt-8 justify-center lg:justify-start">
              <span className="inline-flex items-center gap-1 text-xs text-background-50/70 whitespace-nowrap">
                <i className="ri-check-line text-accent-400 text-xs w-4 h-4 flex items-center justify-center"></i> Updated Daily
              </span>
              <span className="inline-flex items-center gap-1 text-xs text-background-50/70 whitespace-nowrap">
                <i className="ri-check-line text-accent-400 text-xs w-4 h-4 flex items-center justify-center"></i> Verified Finds
              </span>
              <span className="inline-flex items-center gap-1 text-xs text-background-50/70 whitespace-nowrap">
                <i className="ri-check-line text-accent-400 text-xs w-4 h-4 flex items-center justify-center"></i> Safety Guides
              </span>
              <span className="inline-flex items-center gap-1 text-xs text-background-50/70 whitespace-nowrap">
                <i className="ri-check-line text-accent-400 text-xs w-4 h-4 flex items-center justify-center"></i> QC Tutorials
              </span>
            </div>
          </div>

          <div className="hidden lg:flex flex-1 justify-center">
            <div className="grid grid-cols-2 gap-3 w-full max-w-md">
              {stats.map((stat, idx) => (
                <div
                  key={idx}
                  className="bg-background-50/10 backdrop-blur-sm border border-background-50/20 rounded-xl p-5 text-center"
                >
                  <p className="text-2xl md:text-3xl font-heading font-bold text-background-50">{stat.value}</p>
                  <p className="text-xs text-background-50/70 mt-1">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <div className="w-6 h-10 border-2 border-background-50/30 rounded-full flex items-start justify-center p-1.5">
          <div className="w-1 h-2.5 bg-background-50/50 rounded-full animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}